import React from 'react'
import { Box, Stack, Typography } from '@mui/material'

import type { PaymentStep } from '@/src/utils/holidays/parsePaymentSchedule'

interface PaymentScheduleProps {
    steps: PaymentStep[]
    isMobile: boolean
}

const PaymentSchedule: React.FC<PaymentScheduleProps> = ({ steps, isMobile }) => {
    return (
        <Stack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 2 : 3}>
            {steps.map((step, index) => (
                <Box key={step.trigger + step.amount} sx={{ flex: 1, minWidth: 0 }}>
                    {/* Dot, then a rule running toward the next step. */}
                    <Stack direction="row" spacing={1} sx={{ alignItems: 'center', mb: 1.25 }}>
                        <Box
                            sx={{ width: 12, height: 12, borderRadius: '50%', flexShrink: 0, bgcolor: 'primary.main' }}
                        />
                        {index < steps.length - 1 && <Box sx={{ flex: 1, height: 2, bgcolor: 'borders.default' }} />}
                    </Stack>

                    <Typography
                        sx={{
                            // Sentence case, not uppercase: these triggers run to a full clause
                            // ("45 days before departure or with visa submission whichever comes
                            // first") and shouting a sentence is unreadable.
                            fontSize: isMobile ? '0.75rem' : '1rem',
                            fontWeight: 700,
                            color: 'primary.main',
                            mb: 0.5,
                            lineHeight: 1.4
                        }}
                    >
                        {step.trigger}
                    </Typography>

                    <Typography
                        sx={{
                            fontSize: isMobile ? '1rem' : '1.125rem',
                            fontWeight: 700,
                            color: 'textColors.primary',
                            lineHeight: 1.3
                        }}
                    >
                        {step.amount}
                    </Typography>

                    {step.note && (
                        <Typography
                            sx={{
                                fontSize: isMobile ? '0.75rem' : '1rem',
                                color: 'textColors.secondary',
                                mt: 0.5,
                                lineHeight: 1.5
                            }}
                        >
                            {step.note}
                        </Typography>
                    )}
                </Box>
            ))}
        </Stack>
    )
}

export { PaymentSchedule }
export default PaymentSchedule
